export const VERIFY_PHONE = 'VERIFY_PHONE';
export const VERIFY_PHONE_SUCCESS = 'VERIFY_PHONE_SUCCESS';
export const VERIFY_PHONE_ERROR = 'VERIFY_PHONE_ERROR';

export const PUT_CONTACT_DETAILS = 'PUT_CONTACT_DETAILS';
export const PUT_CONTACT_DETAILS_SUCCESS = 'PUT_CONTACT_DETAILS_SUCCESS';
export const PUT_CONTACT_DETAILS_ERROR = 'PUT_CONTACT_DETAILS_ERROR';

export const PUT_PERSONAL_INFO = 'PUT_PERSONAL_INFO';
export const PUT_PERSONAL_INFO_SUCCESS = 'PUT_PERSONAL_INFO_SUCCESS';
export const PUT_PERSONAL_INFO_ERROR = 'PUT_PERSONAL_INFO_ERROR';

export const VALIDATE_PHONE_OTP = 'VALIDATE_PHONE_OTP';
export const VALIDATE_PHONE_OTP_SUCCESS = 'VALIDATE_PHONE_OTP_SUCCESS';
export const VALIDATE_PHONE_OTP_ERROR = 'VALIDATE_PHONE_OTP_ERROR';

export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';

export const CLOSE_MODAL = "CLOSE_MODAL";

export const VERIFY_ACCOUNT_NO = 'VERIFY_ACCOUNT_NO';
export const VERIFY_ACCOUNT_NO_SUCCESS = 'VERIFY_ACCOUNT_NO_SUCCESS';
export const VERIFY_ACCOUNT_NO_ERROR = 'VERIFY_ACCOUNT_NO_ERROR';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const PUT_PERSONAL_DOCUMENTS = 'PUT_PERSONAL_DOCUMENTS';
export const PUT_PERSONAL_DOCUMENTS_SUCCESS = 'PUT_PERSONAL_DOCUMENTS_SUCCESS';
export const PUT_PERSONAL_DOCUMENTS_ERROR = 'PUT_PERSONAL_DOCUMENTS_ERROR';

export const UPDATE_COMPANY_INFO = 'UPDATE_COMPANY_INFO';
export const UPDATE_COMPANY_INFO_SUCCESS = 'UPDATE_COMPANY_INFO_SUCCESS';
export const UPDATE_COMPANY_INFO_ERROR = 'UPDATE_COMPANY_INFO_ERROR';

export const UPDATE_COMPANY_DOCS = 'UPDATE_COMPANY_DOCS';
export const UPDATE_COMPANY_DOCS_SUCCESS = 'UPDATE_COMPANY_DOCS_SUCCESS';
export const UPDATE_COMPANY_DOCS_ERROR = 'UPDATE_COMPANY_DOCS_ERROR';

export const UPDATE_DIRECTOR_DETAILS = "UPDATE_DIRECTOR_DETAILS";
export const UPDATE_DIRECTOR_DETAILS_SUCCESS = "UPDATE_DIRECTOR_DETAILS_SUCCESS";
export const UPDATE_DIRECTOR_DETAILS_ERROR = "UPDATE_DIRECTOR_DETAILS_ERROR";

export const GET_DIRECTOR_DETAILS = "GET_DIRECTOR_DETAILS";
export const GET_DIRECTOR_DETAILS_SUCCESS = "GET_DIRECTOR_DETAILS_SUCCESS";
export const GET_DIRECTOR_DETAILS_ERROR = "GET_DIRECTOR_DETAILS_ERROR";

export const DELETE_DIRECTOR = "DELETE_DIRECTOR";
export const DELETE_DIRECTOR_SUCCESS = "DELETE_DIRECTOR_SUCCESS";
export const DELETE_DIRECTOR_ERROR = "DELETE_DIRECTOR_ERROR";

export const UPDATE_BANK_DETAILS = "UPDATE_BANK_DETAILS";
export const UPDATE_BANK_DETAILS_SUCCESS = "UPDATE_BANK_DETAILS_SUCCESS";
export const UPDATE_BANK_DETAILS_ERROR = "UPDATE_BANK_DETAILS_ERROR";